import { createPlaque } from "/plaque/create_plaque.js";
import { createElement } from "/elements_functions/new_elements.js";

function checkResponseForCaptchaAndDisplay(response, retryFunction) {
    if(response.status === 405 && response.headers.get("x-amzn-waf-action") === "captcha") {
        createCaptchaWindowWithPlaque(retryFunction);
    }
}

function createCaptchaWindow(retryFunction, onError) {
    const captchaWindow = createElement('div', null, ['captcha-window']);

    AwsWafCaptcha.renderCaptcha(captchaWindow,
        {
            apiKey : 'q5APhgLdk3+48n9N4GN82RM7q8ZJLWYSB+6yfWrPcLMNj6HxyDYxhYMMu/HQrn/FL+lgOO6Ppdu8oGfuhCnIRn61xftfo2nbTxXHuDsEoWM4HhmjGaJIMNARI2EeRJ6Kqy0nHjRV7vd2hEKGlDJW8wTpovbU2IYOBSzDWByJUFoBjEovIJ72i9g5EHzSsBQ9eFZDO8AbUEQ9FV/Hfxuj57YUWe1FZqmfUkT3fI9sfOru2lvoFQLzF5wBy7TUluqTGEEojYhENmxOd6Sdoot2UWYTzeGeLqQoexAMiKvbUZo6u2HD4EwRIGR/zDIOjckzPwDde6whY0eoe8NzPk+NtPps5tvHXUqUZzVMTLCng7xkSn5Y3craXAua3dtbtaCN2Mjyz37Ktas6nDHRrStFxMVrwAPgUhdfgNAEIsayFhNBt0NAJxGmIcUdENYCrkx+NOGhofRjvRLKfk2iAYmj0ka2l5N8QH2aspyp7FVNktOP1MDHWPxruJ5A6kg85yyHXxsgxqcQ8TSth8bIgSmIhzBQwGSaK5h18M2hfBrq+ojBAQ1k2r+uex4P9kCrd0Zl15KFKoaGYKBH9v38oQkGte3PtPp/6vIJcowuCap9JNc9YzmD6ZwJsWM32X3FKGFt40XBvteCE2Ji4yR11FscrD6VuZ0lZ3wDGuEXX5bBi5I=_1_1',
            onSuccess : (captchaToken) => retryFunction(captchaToken),
            onError : (err) => onError(err)
        }
    );

    return captchaWindow;
}

export function createCaptchaWindowWithPlaque(retryFunction, onError) {
    const plaque = createPlaque();
    plaque.makePlaqueQuitToggle('Abort the challenge?', 'No', 'Yes');

    const captchaWindow = createCaptchaWindow(
        (captchaToken) => {
            retryFunction(captchaToken);
            plaque.remove();
        },

        (err) => {
            onError(err);
        });

    plaque.append(captchaWindow);

    return plaque;
}